<template>
	<div class="shadow-lg fixed pin-t w-screen bg-gray-900 z-10">
		<div class="h-16 px-6 xs:py-4">
			<div class="flex justify-between items-center">
				<div class="w-1/3"></div>
				<h1 class="text-xl sm:text-2xl text-white text-center flex-grow">Matthew Carson</h1>
				<div class="w-1/3 flex justify-end py-4 xs:py-0">
					<button @click="showDropdown = !showDropdown">
						<svg class="md:hidden fill-current text-white hover:opacity-75 h-6 cursor-pointer" 
							 xmlns="http://www.w3.org/2000/svg" 
							 viewBox="0 0 20 20">
							<path v-if="showDropdown" d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/>
							<path v-else d="M0 3h20v2H0V3zm0 4h20v2H0V7zm0 4h20v2H0v-2zm0 4h20v2H0v-2z"/>
						</svg>
					</button>
					<div class="hidden md:flex justify-end w-full">
						<div class="mt-2 px-2" @click.prevent="smoothScroll('#about')">
							<a href="#about" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">About</a>
						</div>
						<div class="mt-2 px-2" @click.prevent="smoothScroll('#skills')">
							<a href="#skills" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">Skills</a>
						</div>
						<div class="mt-2 px-2" @click.prevent="smoothScroll('#projects')">
							<a href="#projects" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">Projects</a>
						</div>
						<div class="mt-2 px-2" @click.prevent="smoothScroll('#contact')">
							<a href="#contact" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">Contact</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="md:hidden block bg-blue-darkest pin-r" v-show="showDropdown" :class="showDropdown ? 'border-t-2' : ''"> <!-- mobile nav -->
			<div class="flex flex-col">
				<div class="flex" @click.prevent="smoothScroll('#about')">
					<a href="#about" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">About</a>
				</div>
				<div class="flex" @click.prevent="smoothScroll('#skills')">
					<a href="#skills" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">Skills</a>
				</div>
				<div class="flex" @click.prevent="smoothScroll('#projects')">
					<a href="#projects" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">Projects</a>
				</div>
				<div class="flex" @click.prevent="smoothScroll('#contact')">
					<a href="#contact" class="no-underline font-thin text-white mx-auto my-4 hover:opacity-75">Contact</a>
				</div>
			</div>
		</div> <!-- End mobile nav -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showDropdown: false
			}
		},
		methods: {
			smoothScroll(element) {
				document.querySelector(element).scrollIntoView({ behavior: 'smooth' })
			}
		}
	}
</script>
